<template>
    <div class="padding-from-top">
        <div class="container">
            <div class="row" style="margin-top: 20px">
                <ProductTree/>
                <DirectAccess/>
            </div>
        </div>
    </div>

</template>

<script>
    import ProductTree from "./ProductTree";
    import DirectAccess from "./DirectAccess";
    import {v1 as uuidv1} from "uuid";
    export default {
        name: "StartPage",
        components: {DirectAccess, ProductTree},
        created() {
            this.resetAllValues()
        },
        methods: {
            resetAllValues() {
                let loadingFlag = uuidv1();
                this.$store.commit('setLoadingFlag', loadingFlag);
                this.$store.commit('setKonfigModelAfterRequest', {});
                this.$store.commit('setKonfigModelValidationMode', 'MERKMALE');
                this.$store.dispatch('setProductBreadcrumb', '')
                this.$store.dispatch('setDirectAccessVisibility', true);
                this.$store.dispatch('setProductList', {})
                this.$store.dispatch('setProductSizes', {})
                this.$store.commit('setKonfigModel', {})
                this.$store.commit('removeLoadingFlag', loadingFlag)
            },
        }
    }

</script>

<style scoped>
    .padding-from-top {
        padding-top: 75px;
    }
</style>